<template>
    <section class="pt-8 pb-2 bg-white shadow-lg">
      <div class="container px-4 mx-auto">
        <div class="flex flex-wrap -mx-3">
          <div class="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
            <div class="p-8 text-center ">
              <p class="mb-2 text-xs md:text-base ">Presale</p>
              <span class="text-3xl lg:text-4xl font-bold font-heading">30%(300M)</span>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
            <div class="p-8 text-center ">
              <p class="mb-2 text-xs md:text-base ">Community & Rewards</p>
              <span class="text-3xl lg:text-4xl font-bold font-heading">25% (250M)</span>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
            <div class="p-8 text-center ">
              <p class="mb-2 text-xs md:text-base ">Team & Advisors
              </p>
              <span class="text-3xl lg:text-4xl font-bold font-heading">15% (150M)</span>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
            <div class="p-8 text-center ">
              <p class="mb-2 text-xs md:text-base ">Team & Advisors
              </p>
              <span class="text-3xl lg:text-4xl font-bold font-heading">10% (100M)</span>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
            <div class="p-8 text-center ">
              <p class="mb-2 text-xs md:text-base ">Liquidity
              </p>
              <span class="text-3xl lg:text-4xl font-bold font-heading">20% (200M)</span>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
            <div class="p-8 text-center ">

              <p class="mb-2 text-xs md:text-base ">Total Supply</p>
              <span class="text-3xl lg:text-4xl font-bold font-heading">1B MAYA</span>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
    name:"Detail"
}
</script>

<style>

</style>